<template>
  <!-- 微型简答题 -->
  <div class="bl_input">
    <div v-if="!data.answered">
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.rule?data.rule.subTitle:false">{{data.rule.subTitle}}</span>
        </div>
        <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
        </div>
      </div>
      <!-- 答案部分 -->
      <div class="answer">
        <div class="input-wrapper">
        <el-input v-model="input" :placeholder="''" @focus="handleFocus" @blur="handleBlur"></el-input>
        <div class="custom-placeholder" v-if="!input && !isFocus" :class="{ 'scrolling': shouldScroll }">
          <span ref="placeholderText" class="placeholder-text">{{ placeholderText }}</span>
        </div>
      </div>
        <!-- <el-input v-model="input" :placeholder="data.rule?(data.rule.placeholder?data.rule.placeholder:'请输入内容'):'请输入内容'"></el-input> -->
      </div>
    </div>
    <div v-else>
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.rule?data.rule.subTitle:false">{{data.rule.subTitle}}</span>
        </div>
        <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
        </div>
      </div>
      <!-- 答案部分 -->
      <div class="answer">
        <!-- <el-input v-model="input" :disabled="disabledBol" :placeholder="data.rule?(data.rule.placeholder?data.rule.placeholder:'请输入内容'):'请输入内容'"></el-input> -->
        <div class="input-wrapper">
          <el-input v-model="input" :disabled="disabledBol" :placeholder="''" @focus="handleFocus" @blur="handleBlur"></el-input>
          <div class="custom-placeholder" v-if="!input && !isFocus" :class="{ 'scrolling': shouldScroll }">
            <span ref="placeholderText" class="placeholder-text">{{ placeholderText }}</span>
          </div>
        </div>
      </div>
      <div class="other" v-if="otherBol">
        <div class="other_title">其它答案：<span class="cursor" v-if="otherList.length" @click="getChange">换一换</span></div>
        
        <div class="other_item"
        v-for="i in otherList"
        :key="i.examQuestionId">· {{i.answer}}。</div>
        <!-- 没有其他时 -->
        <div class="other_item_no" v-if="!otherList.length">
          还没有其它哦~
        </div>
        <div class="other_border"></div>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object,
    disabledBol: Boolean
  },
  name: 'BlInput',
  computed: {
    placeholderText () {
      return this.data.rule && this.data.rule.placeholder ? this.data.rule.placeholder : '请输入内容'
    },
    shouldScroll () {
      return this.placeholderWidth > this.containerWidth
    },
    answerObj () {
      let obj
      let length = this.data.rule ? this.data.rule.length : 999999
      if (this.input.length > length) {
        obj = {
          msg: '超出答题字数'
        }
      } else if (this.input.length === 0 && !this.data.rule.notNecessary) {
        obj = {
          msg: '请输入回答后提交'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: this.input
        }
      }
      return obj
    },
    // 其他回答是否展示
    otherBol () {
      let bol = this.data.rule ? (this.data.rule.notGetAnswer !== 1) : true
      return bol
    }
  },
  data () {
    return {
      input: '',
      otherList: [],
      isFocus: false,
      placeholderWidth: 0,
      containerWidth: 0,
      scrollAnimation: null
    }
  },
  methods: {
    handleFocus () {
      this.isFocus = true
      this.stopScrollAnimation()
    },
    handleBlur () {
      this.isFocus = false
      if (!this.input) {
        this.$nextTick(() => {
          this.checkPlaceholderWidth()
          if (this.shouldScroll) {
            this.startScrollAnimation()
          }
        })
      }
    },
    checkPlaceholderWidth () {
      const placeholderEl = this.$refs.placeholderText
      const wrapperEl = this.$el.querySelector('.input-wrapper')
      if (placeholderEl && wrapperEl) {
        this.placeholderWidth = placeholderEl.offsetWidth
        this.containerWidth = wrapperEl.offsetWidth
      }
    },
    startScrollAnimation () {
      if (this.scrollAnimation) {
        return
      }
      const placeholderEl = this.$refs.placeholderText
      if (!placeholderEl) return
      
      const maxScroll = this.placeholderWidth - this.containerWidth
      const pauseTime = 2000
      const scrollSpeed = 1
      
      const scrollAnimationStep = () => {
        let currentScroll = 0
        
        const animate = () => {
          currentScroll += scrollSpeed
          if (currentScroll >= maxScroll) {
            currentScroll = maxScroll
            placeholderEl.style.transform = `translateX(-${currentScroll}px)`
            setTimeout(() => {
              placeholderEl.style.transform = 'translateX(0)'
              setTimeout(scrollAnimationStep, pauseTime)
            }, pauseTime)
            return
          }
          placeholderEl.style.transform = `translateX(-${currentScroll}px)`
          this.scrollAnimation = requestAnimationFrame(animate)
        }
        
        animate()
      }
      
      setTimeout(scrollAnimationStep, pauseTime)
    },
    stopScrollAnimation () {
      if (this.scrollAnimation) {
        cancelAnimationFrame(this.scrollAnimation)
        this.scrollAnimation = null
      }
      const placeholderEl = this.$refs.placeholderText
      if (placeholderEl) {
        placeholderEl.style.transform = 'translateX(0)'
      }
    },
    // 获取换一换
    getChange () {
      if (!this.otherBol) {
        return
      }

      let data = {
        taskRelationId: this.$route.query.taskRelationId,
        questionId: this.data.questionId,
        pageMode: 5
      }
      this.$api.post('ANSWER_LIST', data, (res) => {
        this.otherList = res.data.list || []
      })
    },
    // 初始化
    init () {
      if (this.data.answered) {
        this.input = this.data.answered
        this.getChange()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.checkPlaceholderWidth()
      if (this.shouldScroll && !this.input && !this.isFocus) {
        this.startScrollAnimation()
      }
    })
  },
  created () {
    this.init()
  },
  beforeDestroy () {
    this.stopScrollAnimation()
  }
}
</script>

<style lang="scss" scoped>
.bl_input{
  margin-top: 24px;
  .question{
    margin-bottom: 16px;
    font-size: 16px;
    .title{
      color: #303133;
      .span{
        color: #909399;
        font-size: 12px;
        word-break: break-word;
      }
    }
    .text{
      font-size: 12px;
      line-height: 20px;
      color: #606266;
      margin-top: 8px;
      word-break: break-word;
      white-space: pre-wrap;
    }
  }
  .other{
    margin-top: 32px;
    .other_title, .other_item{
      font-size: 14px;
      line-height: 20px;
      span{
        margin-left: 16px;
        color: #296BFF;
      }
    }
    .other_title{
      margin-bottom: 16px;
    }
    .other_border{
      border-top: 1px solid #EBEEF5;
      margin-top: 32px;
    }
    .other_item_no{
      color: #909399;
      font-size: 12px;
      line-height: 17px;
    }
  }.input-wrapper{
    position: relative;
    overflow: hidden;
    /deep/ .el-input__inner{
      padding-right: 40px;
    }
  }
  .custom-placeholder{
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    pointer-events: none;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 55px);
    .placeholder-text{
      display: inline-block;
      color: #c0c4cc;
      font-size: 14px;
      transition: transform 0.1s forwards;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/input.vue